import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InspectionChargesModalService {

  private selectedInspectionChargeSubject = new BehaviorSubject<any>(null);
  public selectedInspectionCharge$ = this.selectedInspectionChargeSubject.asObservable();

  constructor() { }

  setSelectedInspectionCharge(inspectionCharge: any): void {
    this.selectedInspectionChargeSubject.next(inspectionCharge);
  }

  clearSelectedInspectionCharge(): void {
    this.selectedInspectionChargeSubject.next(null);
  }

  getSelectedInspectionCharge(): any {
    return this.selectedInspectionChargeSubject.value;
  }
}
